import {
  Box,
  Checkbox,
  FormControlLabel,
  makeStyles,
  Paper,
  Tab,
} from "@material-ui/core";
import { TabContext, TabList } from "@material-ui/lab";
import { withStyles } from "@material-ui/styles";
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import AdminTitle2 from "components/admin/smart-visa/AdminTitle2";
import AllDocuments from "components/admin/smart-visa/AllDocuments";
import ButtonVisaStatus from "components/admin/smart-visa/ButtonVisaStatus";
import DocumentForm from "components/admin/smart-visa/DocumentForm";
import { format } from "date-fns";
import { useFormik } from "formik";
import { boiDepartmentId, changeServiceId } from "libs/configs/constant";
import useModalLoading from "libs/hooks/useModalLoading";
import { get } from "lodash-es";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getSmartList } from "redux/modules/allDocumentsSearchSlice";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import DatetimeService from "services/DatetimeService";
import * as yup from "yup";

const GreenCheckbox = withStyles((theme) => ({
  root: {
    color: theme.palette.success.main,
    "&$checked": {
      color: theme.palette.success.main,
    },
  },
  checked: {},
}))((props) => <Checkbox color="default" {...props} />);

function createData(date, doc, firstname, lastname, type, status, staff) {
  return { date, doc, firstname, lastname, type, status, staff };
}

const useStyles = makeStyles((theme) => ({
  warpListVisa: {
    marginTop: 50,
  },
  warpButton: {
    marginTop: 30,
    // display: 'flex',
    // justifyContent: 'space-between',
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  warpForm: {
    marginTop: 30,
  },
  warpRespon: {
    textAlign: "right",
    marginTop: 15,
  },
  table: {
    minWidth: 700,
  },
  tableHead: {
    backgroundColor: "#F1F3F9",
    color: "#8898AA",
    textAlign: "center",
  },
  buttonViewDetail: {
    // width: 150,
    backgroundColor: "#00D0FF",
  },
  warpButtonDetail: {
    display: "flex",
    alignItems: "center",
  },
  buttonStatusDetail: {
    marginLeft: 15,
    backgroundColor: "white",
    padding: 5,
    borderRadius: "50%",
    boxShadow: "0px 0px 2px 2px rgba(23, 43, 77, 0.2)",
  },
  popover: {
    pointerEvents: "none",
  },
  popoverContent: {
    // pointerEvents: 'auto',
  },
  rowPopover: {
    // position: 'relative',
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  rowMenuPopOver: {
    padding: 15,
  },
  rowPopTitle: {
    paddingBottom: "15px",
    borderBottom: "1px solid lightgray",
    fontWeight: "500",
    color: "#101A5F",
    textAlign: "center",
    marginBottom: 15,
  },
  rowPopItem: {
    padding: 5,
    fontWeight: "500",
    color: "#101A5F",
    display: "flex",
    justifyContent: "flex-start",
  },
  iconPop: {
    color: "white",
    fontWeight: "bold",
    marginRight: "10px",
    borderRadius: "50%",
    verticalAlign: "middle",
    width: "25px",
    height: "25px",
  },
}));

function AllDocumentPage() {
  const { t, i18n } = useTranslation();
  const { showLoading, hideLoading } = useModalLoading();
  const [tabValue, setTabValue] = useState("");
  // const [docParams, setDocParams] = useState(null);
  const [docStatus, setDocStatus] = useState(true);

  const [serviceSelected, setServiceSelected] = useState([]);
  // const [responsible, setResponsible] = useState(true);
  const profile = useSelector((state) => state.user.profile);

  const colors = [
    "#1787BA",
    "#007B6B",
    "#006B9C",
    "#001D44",
    "#00BCFF",
    "#005381",
    "#00BCFF",
    "#4DA79B",
  ];

  const classes = useStyles();
  const { list } = useSelector((state) => state.allDocumentsSearch);

  const dispatch = useDispatch();
  const validationSchema = yup.object({
    // partA: yup.object({
    //     firstName: yup.string().required("First name is a required field"),
    //     lastName: yup.string().required("Last name is a required field"),
    // })
  });

  const flDate = DatetimeService.getFirstAndLastDayOfMonth(new Date());
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      statusProcess: "",
      smartService: "",
      // startDate: flDate.firstDate,
      // endDate: flDate.lastDate,
      startDate: null,
      endDate: null,
      keyword: "",
      responsible: true,
    },
    validationSchema,
    onSubmit: async (values) => {
      showLoading();
      getData();
      hideLoading();
    },
  });

  useEffect(() => {
    dispatch(
      getMasterData({
        smartservice: true,
        statusProcess: true,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    async function fetchData() {
      showLoading();
      if (profile?.departmentId === boiDepartmentId) {
        await getData(null, "P");
      } else {
        await getData(null, "PC");
      }

      hideLoading();
    }
    fetchData();
  }, [formik.values.responsible, docStatus, profile.departmentId]);

  useEffect(() => {}, [list]);

  const getData = async (e, value) => {
    setTabValue(value);
    const body = {
      isBackend: docStatus,
      StatausID: formik.values?.statusProcess,
      resonsibleCase: formik.values?.responsible,
      keyword: formik.values?.keyword,
      startDate: formik.values?.startDate
        ? format(new Date(formik.values?.startDate), "yyyy-MM-dd")
        : null,
      endDate: formik.values?.endDate
        ? format(new Date(formik.values?.endDate), "yyyy-MM-dd")
        : null,
      statusProcessId: value,
    };
    await dispatch(getSmartList(body));
  };

  const masterData = useSelector(selectMasterData);
  const smartservice = get(masterData, "smartservice", []);

  const handleSearchDocStatus = (status) => {
    setDocStatus(status);
  };

  const fetchTab = (profile) => {
    switch (profile) {
      case boiDepartmentId:
        return (
          <>
            <TabList onChange={getData}>
              <Tab label="Pending" value="P" />
              <Tab label="Application registered" value="BR" />
              <Tab label="Request additional documents" value="RAI" />
              <Tab label="Processing" value="PC" />
              <Tab label="All" value={null} />
            </TabList>
          </>
        );
      default:
        return (
          <>
            <TabList onChange={getData}>
              <Tab label="Processing" value="PC" />
              <Tab label="Request additional documents" value="RAI" />
              <Tab label="Approved" value="A" />
              <Tab label="All" value={null} />
            </TabList>
          </>
        );
    }
  };

  return (
    <Paper className={classes.paper}>
      <AdminTitle title="Smart VISA" subTitle="All Documents Qualifications" />

      <div className={classes.warpForm}>
        <DocumentForm formik={formik} onSearchDocuments={(params) => {}} />
      </div>
      <div className={classes.warpListVisa}>
        <AdminTitle2 subTitle="List Documents Smart VISA " />
      </div>
      <div>
        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            {fetchTab(profile?.departmentId)}
          </Box>
        </TabContext>
      </div>
      {/* <div className={classes.warpButton}>
        <ButtonVisaStatus
          active={docStatus}
          onSearchDocuments={(params) => {
            setDocStatus(!docStatus);
            setServiceSelected([]);
          }}
          color="#001D44"
          count={list.length}
          title="All Documents"
        />
        {smartservice
          .map((v) => v)
          .sort((a, b) => {
            return a.seq - b.seq;
          })
          .map(function (service, index) {
            return (
              <ButtonVisaStatus
                active={serviceSelected.indexOf(service.smartserviceId) > -1}
                onSearchDocuments={(params) => {
                  if (serviceSelected.indexOf(params) > -1) {
                    // remove
                    let services = [...serviceSelected];
                    services = services.filter((x) => x !== params);
                    setServiceSelected(services);
                  } else {
                    setServiceSelected([...serviceSelected, params]);
                  }
                }}
                color={index < colors.length ? colors[index] : null}
                count={
                  service.smartserviceId !== changeServiceId
                    ? list.filter(
                        (x) =>
                          x.smartserviceId === service.smartserviceId &&
                          x.typeDocSmartFromID !== "C"
                      ).length
                    : list.filter((x) => x.typeDocSmartFromID === "C").length
                }
                title={service.smartserviceName}
                key={service.smartserviceId}
                {...service}
              />
            );
          })}
      </div> */}
      <div className={classes.warpRespon}>
        <FormControlLabel
          control={<GreenCheckbox />}
          name="responsible"
          value={formik.values.responsible}
          checked={formik.values.responsible}
          onClick={async (event) => {
            formik.setFieldValue("responsible", event.target.checked);
          }}
          label="Responsible Case"
        />
      </div>
      <AllDocuments
        smartList={list.filter((l) => {
          if (
            (serviceSelected.find((x) => x === changeServiceId) &&
              l.typeDocSmartFromID === "C") ||
            (serviceSelected.find((x) => x !== changeServiceId) &&
              l.typeDocSmartFromID !== "C" &&
              serviceSelected.indexOf(l.smartserviceId) > -1) ||
            (docStatus && serviceSelected.length === 0)
          )
            return {
              l,
            };
        })}
      />
    </Paper>
  );
}

export default AllDocumentPage;
